import { createSelector } from 'reselect';

import {
  getOrgSettings,
  getDataFromState,
  getItemsFromState,
  getDataFromStateAndProps,
} from './common';

import { getUsers } from './users';


export const getMeetingNotesWithRequest = createSelector(
  [
    getDataFromState('meetingNotes'),
    getItemsFromState('contacts'),
    getItemsFromState('requests'),
    getUsers,
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
    getOrgSettings('requestLabels'),
  ],
  (meetingNotes, contacts, requests, users, requestSources, requestStatuses, requestLabels) =>
    (requestSources && requestStatuses && requestLabels && users) &&
    Object.keys(meetingNotes).map(key => requests[meetingNotes[key].request] && Object.assign({}, {
      ...meetingNotes[key],
      request: {
        ...requests[meetingNotes[key].request],
        contacts: requests[meetingNotes[key].request].contacts.map(id => contacts[id]),
        source: requestSources[requests[meetingNotes[key].request].source],
        status: requestStatuses[requests[meetingNotes[key].request].status],
        labels: requests[meetingNotes[key].request].labels.map(id => requestLabels[id]),
      } || {},
      createdBy: users[meetingNotes[key].createdBy] || {},
    })),
);

export const getMeetingNotesWithCreator = createSelector(
  [getDataFromStateAndProps('meetingNotes'), getUsers],
  (meetingNotes, users) =>
    Object.keys(meetingNotes).map(key => Object.assign({}, {
      ...meetingNotes[key],
      createdBy: users[meetingNotes[key].createdBy] || {},
    })),
);


export const getMeetingNotes = createSelector(
  [getDataFromState('meetingNotes'), getUsers],
  (meetingNotes, users) =>
    Object.keys(meetingNotes).map(key => Object.assign({}, {
      ...meetingNotes[key],
      createdBy: users[meetingNotes[key].createdBy] || {},
    })),
);



// WEBPACK FOOTER //
// ./src/redux/selectors/meetingNotes.js